import React, { useRef } from 'react';
import { motion, useScroll, useTransform, useSpring } from 'framer-motion';

/**
 * SectionStroke — small decorative curvy SVG stroke placed in empty
 * transition space between sections. Scroll-driven pathLength so it
 * "draws itself" as it enters the viewport.
 */
const SectionStroke = ({
  d,
  viewBox = '0 0 400 120',
  color = '#AA94FF',
  strokeWidth = 12,
  className = '',
  opacity = 0.6,
}) => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({
    target: ref,
    offset: ['start end', 'end start'],
  });
  const pathLength = useSpring(
    useTransform(scrollYProgress, [0.1, 0.8], [0, 1]),
    { damping: 30, stiffness: 100 }
  );

  return (
    <div
      ref={ref}
      aria-hidden="true"
      className={`pointer-events-none w-full ${className}`}
    >
      <svg
        viewBox={viewBox}
        preserveAspectRatio="none"
        className="w-full h-full"
      >
        <motion.path
          d={d}
          fill="none"
          stroke={color}
          strokeOpacity={opacity}
          strokeWidth={strokeWidth}
          strokeLinecap="round"
          vectorEffect="non-scaling-stroke"
          style={{ pathLength }}
        />
      </svg>
    </div>
  );
};

export default SectionStroke;
